import * as types from './actionTypes'
import { templateService } from '../_services'

export function fetchTemplates() {
    return dispatch => {
        return templateService
            .getTemplates()
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_TEMPLATES, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_TEMPLATES_FAILURE, error }
    }
}

export function updateTemplate(data) {
    return function(dispatch) {
        return templateService
            .updateTemplate(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_TEMPLATES, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_TEMPLATES_FAILURE, error }
    }
}

export function addTemplate(data) {
    return function(dispatch) {
        return templateService
            .addTemplate(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_TEMPLATES, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_TEMPLATES_FAILURE, error }
    }
}

export function removeTemplateById(id) {
    return function(dispatch) {
      return templateService
        .removeTemplateById(id)
        .then(payload => {
          dispatch(success(payload));
        })
        .catch(error => {
          dispatch(failure(error.toString()));
        });
    };
  
    function success(payload) {
      return { type: types.REMOVE_TEMPLATE, payload: payload };
    }
    function failure(error) {
      return { type: types.REMOVE_TEMPLATE_FAILURE, error };
    }
  }
